"use strict";

var _taggedTemplateLiteral = require("/root/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var _stylitas = require("@creditas/stylitas");

var _typography = require("@creditas-lab/typography");

var Tag = (0, _stylitas.styled)(_typography.Typography)(function (_ref) {
  var theme = _ref.theme,
      tagColor = _ref.tagColor;
  return (0, _stylitas.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: fit-content;\n    color: ", ";\n    border: 1px solid ", ";\n    box-sizing: border-box;\n    border-radius: 100px;\n    padding: 0 10px;\n    letter-spacing: 1.5px;\n    text-transform: uppercase;\n  "])), theme[tagColor], theme[tagColor]);
});
exports.Tag = Tag;